var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7752 0.775146L22.2191 19.8302L30.8868 2.8548L23.0191 20.2154L38.1937 8.68186L23.5726 20.9095L42.2487 17.1022L23.7702 21.7751L42.2487 26.4481L23.5726 22.6407L38.1937 34.8684L23.0191 23.3349L30.8868 40.6955L22.2191 23.7201L21.7752 42.7751L21.3313 23.7201L12.6636 40.6955L20.5313 23.3349L5.35675 34.8684L19.9778 22.6407L1.30172 26.4481L19.7802 21.7751L1.30172 17.1022L19.9778 20.9095L5.35675 8.68186L20.5313 20.2154L12.6636 2.8548L21.3313 19.8302L21.7752 0.775146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStarIcon);
export default __webpack_public_path__ + "static/media/white-star-icon.adae268993d90d07d49deea4bc01edaf.svg";
export { ForwardRef as ReactComponent };